var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuitsMeLogoGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 998.39 284.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-2,.cls-5,.cls-7,.cls-9{fill-rule:evenodd;}.cls-3{mask:url(#mask);}.cls-4{mask:url(#mask-8);}.cls-5{fill:url(#linear-gradient);}.cls-6{mask:url(#mask-9);}.cls-7{fill:url(#linear-gradient-2);}.cls-8{mask:url(#mask-10);}.cls-9{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 0,
    width: 998.39,
    height: 284.44,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    className: "cls-1",
    points: "0 284.44 998.39 284.44 998.39 0 0 0 0 284.44"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    x: 9.82,
    y: 0,
    width: 177.75,
    height: 182.16,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-4-2",
    "data-name": "mask-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    className: "cls-1",
    d: "M145.5,0a61.38,61.38,0,0,0-19,3.32h0c-23.87,7.85-51.2,21-81.25,39.19h0C16.36,60,3.83,91.76,12.54,125.5h0c7.38,28.62,31.39,50.71,60.77,56.66h0L77,180.77h0l2.28-.87h0c-4.51-1-4.51-1.09,0-.08h0c27.83-10.61,67.53-26.48,60.13-52.55h0c-4.54-16-26.13-21.71-30.89-22.79h0l2.14-.81h0l3.64-1.39h0l3.33-1.28h0c17-6.61,24.8-10.31,34.65-15h0c2.71-1.29,5.58-2.65,8.83-4.17h0c39.76-18.5,23-55.79,22.91-56h0C183.86,25.5,174.18,0,145.63,0h-.13Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -181.05,
    y1: 525.5,
    x2: -181.93,
    y2: 524.62,
    gradientTransform: "matrix(177.75, 0, 0, -182.16, 32354.51, 95731.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ce6cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c54f0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    x: 0,
    y: 102.28,
    width: 177.75,
    height: 182.16,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-7-2",
    "data-name": "mask-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-6",
    className: "cls-1",
    d: "M110.61,103.67l-2.14.81h0l-.13,0h0C80.51,115.06,40.81,130.93,48.21,157h0c4.57,16.12,26.51,21.82,31,22.83h0q37.83-14.41,0,.08h0l-2.28.87h0l-3.64,1.39h0L70,183.43h0c-17,6.62-24.79,10.31-34.64,15h0c-2.71,1.29-5.58,2.65-8.84,4.17h0C5,212.58,0,228.05,0,240.21H0v.25a48.56,48.56,0,0,0,3.6,18.17h0c.11.31,9.79,25.81,38.39,25.81h0a61,61,0,0,0,19.09-3.33h0c23.86-7.84,51.2-21,81.25-39.18h0c28.87-17.45,41.4-49.25,32.7-83h0c-7.38-28.62-31.39-50.71-60.78-56.66h0l-3.64,1.39"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -181.18,
    y1: 525.3,
    x2: -181.95,
    y2: 524.55,
    gradientTransform: "matrix(177.75, 0, 0, -182.16, 32345.25, 95834.13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00dfc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c54f0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    x: 47.31,
    y: 104.45,
    width: 92.96,
    height: 75.37,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-10-2",
    "data-name": "mask-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-9",
    className: "cls-1",
    d: "M48.21,157c4.57,16.12,26.51,21.82,31,22.83h0c27.83-10.61,67.52-26.48,60.13-52.55h0c-4.57-16.11-26.5-21.81-31-22.82h0C80.51,115.06,40.81,130.93,48.21,157"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -180.07,
    y1: 523.46,
    x2: -181,
    y2: 522.88,
    gradientTransform: "matrix(92.96, 0, 0, -75.37, 16875.36, 39572.71)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffce6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7636"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "cls-2",
    d: "M259.87,121c0-6.85,6-11.72,14.17-11.72,8.85,0,14.61,5.31,15.93,13.71h22.8c-2-20.78-17.26-32.72-38.73-32.72-23.69,0-36.75,15-36.75,30.73,0,39.13,54.67,27.63,54.67,47.53,0,5.75-5.09,10.83-15.49,10.83-9.3,0-17.49-5.31-18.6-15h-22.8c1.33,20.56,18.16,34,41.4,34,21.25,0,38.3-11.94,38.3-29.84,0-39.35-54.9-27.86-54.9-47.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "cls-2",
    d: "M397.56,151.26c0,16.13-7.3,26.08-22.36,25.86-15.05,0-22.35-9.73-22.35-26.09V92.45H329.6V152.8c0,26.53,17,45.54,45.6,45.54,27.67.22,45.61-19.23,45.61-45.32V92.45H397.56Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    className: "cls-2",
    points: "437.64 196.13 460.88 196.13 460.88 92.45 437.64 92.45 437.64 196.13"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    className: "cls-2",
    d: "M449.37,44.48A14.7,14.7,0,1,0,464.2,59.29a14.73,14.73,0,0,0-14.83-14.81"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    className: "cls-2",
    d: "M519.77,57.75H496.31v34.7h-18.6v19.23h18.82v48.86c0,23.88,15.72,37.14,37,37.14a56.48,56.48,0,0,0,14.61-2V176.45c-4.43.23-6.86.23-8.19.23-13.95,0-20.15-4.86-20.15-19v-46H550.1V92.45H519.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    className: "cls-2",
    d: "M582.64,121c0-6.85,6-11.72,14.17-11.72,8.85,0,14.61,5.31,15.94,13.71h22.8c-2-20.78-17.27-32.72-38.74-32.72-23.69,0-36.75,15-36.75,30.73,0,39.13,54.68,27.63,54.68,47.53,0,5.75-5.09,10.83-15.5,10.83-9.29,0-17.48-5.31-18.59-15h-22.8c1.33,20.56,18.15,34,41.39,34,21.26,0,38.3-11.94,38.3-29.84,0-39.35-54.9-27.86-54.9-47.53"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    className: "cls-2",
    d: "M797.16,90.24c-20.81,0-31.66,13.49-33.88,18.79h-.43c-2.44-5.3-13.29-18.79-34.1-18.79-27.23,0-43.61,18.57-43.61,45.54v60.35h23.25V137.55c0-16.14,7.08-26.09,21.47-26.09s21.47,10,21.47,26.31v58.58h23.25V137.77c0-16.36,7.08-26.31,21.47-26.31s21.47,10,21.47,26.09v58.58h23.25V135.78c0-27-16.16-45.54-43.61-45.54"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    className: "cls-2",
    d: "M878.85,135.12c3.1-14.81,14.17-24.54,29.45-24.54a27.44,27.44,0,0,1,27.44,24.54ZM908.3,90.24c-31,0-52.69,22.55-52.69,54.16,0,31.84,21.91,53.94,52.9,53.94,22.14,0,41.18-12.38,47.6-33.38h-22.8c-4.43,8.62-12.4,13-25,13-15.06,0-26.35-9.28-29.45-25.2h79.7c.22-3.31.22-5.08.22-8.4,0-30.95-22.14-54.16-50.47-54.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    className: "cls-2",
    d: "M983.56,168.94a14.7,14.7,0,1,0,14.83,14.81,14.73,14.73,0,0,0-14.83-14.81"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    className: "cls-5",
    d: "M145.5,0a61.38,61.38,0,0,0-19,3.32h0c-23.87,7.85-51.2,21-81.25,39.19h0C16.36,60,3.83,91.76,12.54,125.5h0c7.38,28.62,31.39,50.71,60.77,56.66h0L77,180.77h0l2.28-.87h0c-4.51-1-4.51-1.09,0-.08h0c27.83-10.61,67.53-26.48,60.13-52.55h0c-4.54-16-26.13-21.71-30.89-22.79h0l2.14-.81h0l3.64-1.39h0l3.33-1.28h0c17-6.61,24.8-10.31,34.65-15h0c2.71-1.29,5.58-2.65,8.83-4.17h0c39.76-18.5,23-55.79,22.91-56h0C183.86,25.5,174.18,0,145.63,0h-.13Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    className: "cls-7",
    d: "M110.61,103.67l-2.14.81h0l-.13,0h0C80.51,115.06,40.81,130.93,48.21,157h0c4.57,16.12,26.51,21.82,31,22.83h0q37.83-14.41,0,.08h0l-2.28.87h0l-3.64,1.39h0L70,183.43h0c-17,6.62-24.79,10.31-34.64,15h0c-2.71,1.29-5.58,2.65-8.84,4.17h0C5,212.58,0,228.05,0,240.21H0v.25a48.56,48.56,0,0,0,3.6,18.17h0c.11.31,9.79,25.81,38.39,25.81h0a61,61,0,0,0,19.09-3.33h0c23.86-7.84,51.2-21,81.25-39.18h0c28.87-17.45,41.4-49.25,32.7-83h0c-7.38-28.62-31.39-50.71-60.78-56.66h0l-3.64,1.39"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-22"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-20",
    className: "cls-9",
    d: "M48.21,157c4.57,16.12,26.51,21.82,31,22.83h0c27.83-10.61,67.52-26.48,60.13-52.55h0c-4.57-16.11-26.5-21.81-31-22.82h0C80.51,115.06,40.81,130.93,48.21,157"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitsMeLogoGradient);
export default __webpack_public_path__ + "static/media/SuitsMe_Logo_Gradient.28cba4482c491a9c5030a3b0dd0f4221.svg";
export { ForwardRef as ReactComponent };